.toggleItem {
  display: flex;
  flex-direction: row;
  gap: var(--m-sp-xs);
  align-items: center;

  &:disabled {
    @apply --mx-bg(var(--m-gray-light));
    @apply --mx-fg(var(--m-gray-ink));
  }
}
